import React from 'react';
import { motion } from 'framer-motion';
export function CreatorQuote() {
  return <section className="py-10 sm:py-12 px-4 bg-brand-dark border-y border-white/5" data-id="element-79">
      <div className="max-w-3xl mx-auto text-center" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-81">
          <p className="text-xs font-black uppercase tracking-widest text-brand-orange mb-6" data-id="element-82">
            A proposito di Metodo Economia Aziendale Pro™
          </p>

          <blockquote className="text-lg sm:text-2xl font-medium text-brand-cream italic leading-relaxed mb-8" data-id="element-83">
            "Ho riunito in questo Metodo le risorse operative reali per
            trasformare lezioni improvvisate in percorsi didattici
            professionali, documentati e riconoscibili dal MIM. L'obiettivo è
            uno solo: ridare ossigeno ai docenti di Economia Aziendale,
            togliendo il peso soffocante della preparazione manuale.{' '}
            <span className="bg-gradient-to-r from-brand-orange via-brand-amber to-brand-gold bg-clip-text text-transparent font-black not-italic" data-id="element-84">
              Più tempo per insegnare. Meno tempo per pianificare.
            </span>
            "
          </blockquote>

          <div className="font-black text-gray-400 text-base sm:text-lg leading-tight" data-id="element-85">
            — Metodo Economia Aziendale Pro™
            <br data-id="element-86" />
            <span className="text-sm text-gray-500 font-bold" data-id="element-87">
              Sistema Didattico Integrato per Docenti di Economia Aziendale ITE
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}